var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormControlLabel as MuiFormControlLabel, Radio as MuiRadio } from '@mui/material';
import React, { useId } from 'react';
import { ThemeUtils, alterResponsiveValues, classNames as cn, getAttributes } from '../../../utils';
import { ContainerWidths } from '../../templates/container';
import { RadioButtonDesignStyles, RadioButtonSizes, RadioButtonStates, isColorButton } from './types';
var RB = function (_a) {
    var props = __rest(_a, []);
    var className = props.className, idProp = props.id, label = props.label, ariaLabel = props["aria-label"], value = props.value, widthProp = props.width, checked = props.checked, disabled = props.disabled, error = props.error, onChange = props.onChange, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onFocus = props.onFocus, onBlur = props.onBlur, state = props.state, _b = props.size, sizeProp = _b === void 0 ? RadioButtonSizes.Size_5 : _b, color = props.color, _c = props.designStyle, designStyle = _c === void 0 ? RadioButtonDesignStyles.Standard : _c, icon = props.icon, checkedIcon = props.checkedIcon, rest = __rest(props, ["className", "id", "label", 'aria-label', "value", "width", "checked", "disabled", "error", "onChange", "onMouseOver", "onMouseLeave", "onFocus", "onBlur", "state", "size", "color", "designStyle", "icon", "checkedIcon"]);
    var defaultId = useId();
    var id = idProp || defaultId;
    var radioButtonConfig = {
        id: id,
        disableRipple: true,
        disabled: disabled,
        checked: checked,
        value: value,
        icon: icon,
        checkedIcon: checkedIcon,
        onChange: onChange,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        sx: __assign(__assign(__assign({}, (designStyle !== RadioButtonDesignStyles.Standard &&
            isColorButton({ color: color }) && {
            color: color,
            background: color
        })), (designStyle === RadioButtonDesignStyles.Rounded &&
            sizeProp && {
            '& .MuiSvgIcon-root': __assign({}, (sizeProp && {
                fontSize: alterResponsiveValues(sizeProp, function (sizeValue) {
                    var adaptedValue = null;
                    if (sizeValue) {
                        adaptedValue = ThemeUtils.getComputedSpacing(Number(sizeValue));
                    }
                    return adaptedValue;
                })
            }))
        })), (widthProp && { width: '100%' })),
        className: cn(className, designStyle && "".concat(designStyle.toLowerCase()), (disabled || state === RadioButtonStates.Disabled) && 'disabled', error && 'error'),
        inputProps: __assign({}, getAttributes(rest))
    };
    var formLabelConfig = {
        htmlFor: id,
        // strict condition (Maybe, Squared type can be refactored)
        label: designStyle === RadioButtonDesignStyles.Standard ? label : null,
        'aria-label': ariaLabel,
        value: value,
        checked: checked,
        disabled: disabled,
        disableTypography: true,
        sx: {
            width: widthProp !== null && widthProp !== void 0 ? widthProp : ContainerWidths.Auto
        }
    };
    return (React.createElement(MuiFormControlLabel, __assign({ control: React.createElement(MuiRadio, __assign({}, radioButtonConfig)) }, formLabelConfig)));
};
export { RB as RadioButton };
